/**
 * Created by JackCui on 2021/1/12
 */

/**
 * json-logic-js的二次封装
 * 添加一些 自定义的操作
 */

import logic from './logic'
import {symbolHandle} from './symbolHandle'

// 添加自定义操作
for (let k in symbolHandle) {
  if (!symbolHandle.hasOwnProperty(k)) {
    continue
  }

  const symbol = symbolHandle[k]
  for (let v in symbol) {
    if (symbol.hasOwnProperty(v)) {
      logic.add_operation(`${k}-${v}`, (a, b) => symbol[v](a, b))
    }
  }
}

export const addCustomOperation = (fieldType, fn) => {
  logic.add_operation(`${fieldType}-${fn.toString()}`, (a, b) => fn(a, b))
}

export default logic
